import styled from 'styled-components';
import { AdvisorHomeHero } from '../../../../ImagePaths';

export const HeroWrapper = styled.div`
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.75) 23.67%,
    rgba(255, 255, 255, 0) 97.97%
  );

  @media (min-width: $screen-sm) {
    height: 55vw;
    min-height: 512px;
  }
`;

export const HeroHeadline = styled.h1`
  animation-duration: 0.5s;
`;
export const HeroLabel = styled.span`
  font-weight: bold;
  color: #4b4687;
  border-radius: 50px;
  padding: 0 2vw;
  position: relative;
  display: inline-block;
  z-index: 1;

  ::after {
    content: '';
    display: block;
    position: absolute;
    top: 5px;
    left: 0;
    right: 0;
    bottom: 0;
    background: #fff;
    z-index: -1;
    border-radius: 50px;
  }
`;

export const BGImage = styled.div`
  height: 1px;
  overflow: visible
  &::after {
    content: '';
    background-color: #e6e7e8;
    background-image: repeating-linear-gradient(
        45deg,
        rgba(230, 231, 232, 0.5) 0,
        rgba(57, 68, 78, 0.5) 520px,
        transparent 520px 520px
      ),
      repeating-linear-gradient(
        45deg,
        rgba(230, 231, 232, 0.25) 400px,
        rgba(57, 68, 78, 0.25) 650px,
        transparent 650px 760px
      ),
      repeating-linear-gradient(
        45deg,
        rgba(61, 112, 148, 0.3) -100px,
        rgba(61, 112, 148, 0.2) 150px,
        rgba(61, 112, 148, 0) 220px,
        transparent 220px 330px
      ),
      repeating-linear-gradient(
        -45deg,
        rgba(61, 112, 148, 0.3) -100px,
        rgba(61, 112, 148, 0.2) 150px,
        rgba(61, 112, 148, 0) 220px,
        transparent 220px 330px
      ),
      repeating-linear-gradient(
        -45deg,
        rgba(230, 231, 232, 0.5) 0,
        rgba(57, 68, 78, 0.5) 520px,
        transparent 520px 520px
      );
    opacity: 0.1;
    position: absolute;
    background-repeat: no-repeat;
    z-index: 0;
    top: 0px;
    left: 0px;
    transform: scale(1.5);
    transition: all 0.5s cubic-bezier(0.44, 0.01, 0.4, 1.34) 0.125s;
    width: 100%;
    height: 100%;

    &.animate {
    &::after {
      transform: translate(0, 0) scale(3);
      border-radius: 0;
      width: 100%;
      height: 100%;
      opacity: 0.1;
    }
  }
`;

export const HeroBg = styled.div`
  background-image: url(${AdvisorHomeHero});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top right;
  z-index: -1;
  border-radius: 100%;
  overflow: hidden;
  opacity: 1;
  position: absolute;
  background-repeat: no-repeat;
  top: 0px;
  width: 100%;
  height: 320px;
  left: 0px;
  transform: scale(1.5);
  @media (min-width: 576px) {
    height: 480px;
  }
  @media (min-width: 768px) {
    background-size: contain;
    background-position: center 100%;
    height: 600px;
  }
  @media (min-width: 992px) {
    background-size: auto;
  }
  @media (min-width: 1900px) {
    background-size: 100%;
    background-position: center 70%;
  }
`;
